'use client';
import { convertLexicalWithInternalLinks } from '@/lib/lexical';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import Image from '@/components/atoms/image';
interface StepOptionItemProps {
    title: any;
    description: any;
    image?: {
        url: string;
        alt?: string;
    };
    index?: number;
}

function extractTextFromLexical(node: any): string {
    if (!node) return '';
    if (Array.isArray(node.children)) {
        return node.children.map(extractTextFromLexical).join('');
    }
    if (node.text) return node.text;
    return '';
}
export const StepOptionItem: React.FC<StepOptionItemProps> = ({ title, description, image, index = 1 }) => {
    const html = convertLexicalWithInternalLinks(description as SerializedEditorState);
    return (
        <div className={` flex flex-col xl:flex-row items-center text-center md:text-start md:items-start gap-[12px] w-full relative ${index % 2 === 0 ? ' md:mt-64 xl:mt-0' : ''}`}>
            <div className='w-[92px] h-[104px] relative' >
                {(image?.url) && (
                    <Image
                        fill
                        className="relative object-contain m-auto"
                        alt={image?.alt || ""}
                        src={`${image.url}`}
                    />
                )}
            </div>
            <div className="flex-1 flex flex-col items-center md:items-start">
                <h6 className="text-l-semibold font-[600] pb-0 m-0 text-[#2B363C]">{extractTextFromLexical(title?.root)}</h6>
                <div
                    className=''
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </div>
        </div>
    );
};
